export default {
  client: {
    create: (options) => {
      if (options?.authorization === 'bt_client_token') return Promise.resolve({})

      alert('Braintree authorization is incorrect')
      return Promise.reject({})
    },
  },
  applePay: {
    create: (options) => {
      if (!options?.client) {
        alert('Braintree client is missing')
        return Promise.reject({})
      }

      return Promise.resolve({
        tokenize: (options) => {
          if (!options?.token?.transactionIdentifier) {
            alert('Braintree apple-pay transaction identifier is missing')
            return Promise.reject({})
          }
          return Promise.resolve({ nonce: '584dbfbe-2eb7-1758-7001-7c81eca2e59b' })
        },
      })
    },
  },
}
